import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowLeft, BookOpen, Clock } from "@phosphor-icons/react";

export default function CourseDetail() {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const [active, setActive] = useState(0);

  useEffect(() => { api.get(`/knowledge/${id}`).then((r) => setCourse(r.data)); }, [id]);

  if (!course) return <div className="text-ink-500">Loading…</div>;
  const mod = course.modules[active];

  return (
    <div className="space-y-8" data-testid="course-detail">
      <Link to="/app/academy" className="inline-flex items-center gap-2 text-sm text-ink-700 hover:text-ink-900" data-testid="back-to-academy"><ArrowLeft weight="thin" size={16} /> Back to Academy</Link>

      <header className="vansha-card overflow-hidden">
        <div className="aspect-[21/9] overflow-hidden">
          <img src={course.cover} alt={course.title} className="w-full h-full object-cover" />
        </div>
        <div className="p-8">
          <p className="overline text-saffron mb-2">{course.category}</p>
          <h1 className="font-serif font-semibold text-4xl sm:text-5xl leading-tight">{course.title}</h1>
          <p className="text-ink-700 mt-3 text-lg">{course.subtitle}</p>
          <div className="flex items-center gap-4 mt-4 text-sm text-ink-500">
            <span className="flex items-center gap-1"><BookOpen weight="thin" size={16} />{course.lessons} lessons</span>
            <span className="flex items-center gap-1"><Clock weight="thin" size={16} />{course.duration}</span>
          </div>
        </div>
      </header>

      <div className="grid lg:grid-cols-3 gap-6">
        <aside className="vansha-card p-6 h-fit lg:sticky lg:top-24" data-testid="course-toc">
          <p className="overline mb-4">Lessons</p>
          <ul className="space-y-1">
            {course.modules.map((m, i) => (
              <li key={i}>
                <button onClick={() => setActive(i)} className={`w-full text-left p-3 rounded-xl text-sm transition ${active === i ? "bg-terracotta text-white" : "text-ink-700 hover:bg-vansha-accent"}`} data-testid={`lesson-${i}`}>
                  <span className="mr-2 opacity-70">{i + 1}.</span> {m.title}
                </button>
              </li>
            ))}
          </ul>
        </aside>

        <article className="lg:col-span-2 vansha-card p-8 sm:p-10" data-testid="lesson-content">
          <p className="overline text-saffron mb-3">Lesson {active + 1} of {course.modules.length}</p>
          <h2 className="font-serif text-3xl leading-tight mb-6">{mod.title}</h2>
          <p className="font-serif text-lg leading-relaxed text-ink-900 whitespace-pre-wrap">{mod.body}</p>
          <div className="mt-10 flex justify-between">
            <button disabled={active === 0} onClick={() => setActive(active - 1)} className="btn-ghost disabled:opacity-40" data-testid="lesson-prev">← Previous</button>
            <button disabled={active === course.modules.length - 1} onClick={() => setActive(active + 1)} className="btn-primary disabled:opacity-40" data-testid="lesson-next">Next lesson →</button>
          </div>
        </article>
      </div>
    </div>
  );
}
